function getCookie(name) {
    let matches = document.cookie.match(new RegExp(
        "(?:^|; )" + name.replace(/([\.$?*|{}\(\)\[\]\\\/\+^])/g, '\\$1') + "=([^;]*)"
    ));
    return matches ? decodeURIComponent(matches[1]) : undefined;
}

const setCookie = (name, value, days, path, domain, secure) => {
    let cookie = `${name}=${encodeURIComponent(value)}`;

    // Add expiry date
    if (days) {
        const expiry = new Date();
        expiry.setDate(expiry.getDate() + days);
        cookie += `; expires=${expiry.toUTCString()}`;
    }

    // Add Path, Domain, and Secure
    if (path) cookie += `; path=${path}`;
    if (domain) cookie += `; domain=${domain}`;
    if (secure) cookie += `; secure`;

    // Set an HTTP cookie
    document.cookie = cookie;
};

const time = 30*24*60*60*1000;

// Пример использования:
// setCookie('name', '', -1);